import { EventDatePriceListModel, PriceGroupModel, UserCreditCardConditionModel, UserMembershipCardModel } from "..";

export type PriceList = {
    IsSuccess: boolean,
    EventDates: EventDatePriceListModel[],
    ShowOnlyWholePricesOnInternet: boolean,
    activeMembershipCards: UserMembershipCardModel[],
    activeCreditCardConditions: UserCreditCardConditionModel[]
}

export type PriceQuantity = {
    priceGroup?: PriceGroupModel;
    quantity?: number;
}